"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Popover = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importStar(require("react"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_common_1 = require("@ryerson/frontend.common");

var uuid_1 = require("uuid");

var react_2 = require("react");

exports.Popover = (0, react_2.forwardRef)(function (props, ref) {
  var _props$alignment = props.alignment,
      alignment = _props$alignment === void 0 ? "bottom" : _props$alignment,
      className = props.className,
      caretColor = props.caretColor,
      _props$hover = props.hover,
      hover = _props$hover === void 0 ? false : _props$hover,
      trigger = props.trigger,
      children = props.children,
      onClose = props.onClose,
      onOpen = props.onOpen,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$offset = props.offset,
      offset = _props$offset === void 0 ? [0, 0] : _props$offset,
      _props$popoverType = props.popoverType,
      popoverType = _props$popoverType === void 0 ? "caret" : _props$popoverType,
      dataTestId = props.dataTestId;

  var _ref = (0, frontend_theme_1.useTheme)(),
      theme = _ref.theme;

  var white = theme.colors.primary.white;

  var _ref2 = (0, react_1.useState)("popper-".concat((0, uuid_1.v4)())),
      _ref3 = _slicedToArray(_ref2, 1),
      popperId = _ref3[0];

  var _ref4 = (0, react_1.useState)(false),
      _ref5 = _slicedToArray(_ref4, 2),
      hasMounted = _ref5[0],
      setHasMounted = _ref5[1];

  var _ref6 = (0, react_1.useState)(false),
      _ref7 = _slicedToArray(_ref6, 2),
      _isOpen = _ref7[0],
      setIsOpen = _ref7[1];

  var itemRef = react_1.default.useRef(null); // Exposed Handles for the Popover - Call these functions from the parent component

  (0, react_2.useImperativeHandle)(ref, function () {
    return {
      open: function open() {
        setIsOpen(true);
      },
      close: function close() {
        setIsOpen(false);
      },
      isOpen: function isOpen() {
        return _isOpen;
      }
    };
  }, []);

  var setTriggerRef = function setTriggerRef(node) {
    triggerRef.current = node;
  };

  !caretColor && (caretColor = white);
  var triggerRef = react_1.default.useRef();

  var handleMouseOver = function handleMouseOver(event) {
    !!hover && setIsOpen(true);
  };

  var handleMouseOut = function handleMouseOut(event) {
    !!hover && setIsOpen(false);
  };

  var handleOnClick = function handleOnClick(event) {
    setIsOpen(function (curState) {
      return !curState;
    });
  }; // Adding a listener to the document to close the popover when the user clicks outside of the popover
  // its namespace to control re-instancing of the listener


  var addListener = function addListener() {
    var addType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "add";

    var handler = function handler(event) {
      var _a;

      if (!((_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.contains(event === null || event === void 0 ? void 0 : event.target))) {
        _isOpen && setIsOpen(false);
        document === null || document === void 0 ? void 0 : document.removeEventListener("mousedown", handler);
      }

      return;
    };

    if (addType === "remove") {
      document === null || document === void 0 ? void 0 : document.removeEventListener("mousedown", handler);
    } else {
      document === null || document === void 0 ? void 0 : document.addEventListener("mousedown", handler);
    }
  };

  react_1.default.useEffect(function () {
    if (hasMounted) {
      if (_isOpen) {
        !!onOpen && onOpen();
        addListener();
      } else {
        !!onClose && onClose();
      }
    }
  }, [_isOpen]);
  react_1.default.useEffect(function () {
    setHasMounted(true);
    return function () {
      setHasMounted(false);
      triggerRef.current = null;
      addListener("remove");
    };
  }, []);
  return (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
    itemRef: itemRef,
    className: "popover-root ".concat(className),
    css: {
      width: "100%"
    },
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      direction: "column",
      alignItems: "center",
      justifyContent: "center",
      css: {
        width: "100%"
      },
      children: [(0, jsx_runtime_1.jsx)("div", Object.assign({
        css: {
          position: "relative",
          width: "100%",
          cursor: disabled ? "unset" : "pointer",
          svg: {
            pointerEvents: "none"
          }
        },
        className: "popover-trigger",
        ref: setTriggerRef,
        onClick: !hover && !disabled ? handleOnClick : function () {}
      }, !!hover && {
        onMouseOver: handleMouseOver
      }, !!hover && {
        onMouseOut: handleMouseOut
      }, !!hover && {
        onMouseLeave: handleMouseOut
      }, {
        "data-testid": dataTestId,
        children: trigger
      })), (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
        children: !!triggerRef.current && (0, jsx_runtime_1.jsx)(frontend_common_1.Popper, {
          id: popperId,
          targetEl: triggerRef.current,
          backColor: popoverType === "caret" ? caretColor : "transparent",
          borderColor: popoverType === "caret" ? caretColor : "transparent",
          offsetX: offset[0],
          offsetY: offset[1],
          placement: alignment,
          isDisplaying: _isOpen,
          children: children
        })
      })]
    })
  });
});